export default __webpack_public_path__ + "static/media/Read.a80523f4.svg";